import { render, staticRenderFns } from "./GunsAndTanks_dialog.vue?vue&type=template&id=4b549ee0&scoped=true&"
import script from "./GunsAndTanks_dialog.vue?vue&type=script&lang=js&"
export * from "./GunsAndTanks_dialog.vue?vue&type=script&lang=js&"
import style0 from "./GunsAndTanks_dialog.vue?vue&type=style&index=0&id=4b549ee0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b549ee0",
  null
  
)

export default component.exports